import React from 'react';
import { useNavigate } from "react-router-dom";
import { logAnalyticsEvent } from "../../../Databases/analytics_consent";
import './WelcomePageHeader.css';
import { useTranslation } from 'react-i18next';


function WelcomePageHeader() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleEmailSignin = () => {
    logAnalyticsEvent("email_signin_attempt");
    navigate("/signin");
  };

  const handleEmailSignup = () => {
    logAnalyticsEvent("email_signup_attempt");
    navigate("/signup");
  };

  return (
    <header className="custom-navbar">
      <a href="/" className="navbar-brand">
        <img
          src="./img/logo.svg"
          alt="Aya Matchmaker Logo"
          width="36"
          height="36"
          className="logoWhite"
        />
      </a>

      <div className="header-actions">
        <button onClick={handleEmailSignin} className="btn nav-btn nav-btn-outline">
          {t('signIn')}
        </button>
        <button onClick={handleEmailSignup} className="btn nav-btn nav-btn-solid">
          {t('signUp')}
        </button>
      </div>
    </header>
  );
}

export default WelcomePageHeader;
